var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUncheckedRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.903 0c6.507 0 11.801 5.384 11.801 12s-5.294 12-11.8 12C5.396 24 .101 18.616.101 12S5.397 0 11.903 0zm5.514 6.387a.992.992 0 0 0-1.402-.012l-4.161 4.16-4.16-4.16-.086-.076a.994.994 0 0 0-1.317.088.992.992 0 0 0-.012 1.402l4.16 4.16-4.16 4.161-.076.086a.994.994 0 0 0 .088 1.317.992.992 0 0 0 1.402.012l4.16-4.161 4.162 4.16.085.077a.994.994 0 0 0 1.317-.088.992.992 0 0 0 .012-1.403l-4.161-4.161 4.16-4.16.077-.086a.994.994 0 0 0-.088-1.316z",
    fill: "#D8D8D8",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedRound);
export default __webpack_public_path__ + "static/media/unchecked-round.3dff55abf7d634cc14b2d364a54f60d6.svg";
export { ForwardRef as ReactComponent };